// extracted by mini-css-extract-plugin
export default {"tableWrapper":"ProjectTimeSettings_tableWrapper__3WsL9","wrap":"ProjectTimeSettings_wrap__73lNB"};